import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ConventionRegistration } from 'app/models/convention-registration.model';
import { DeleteConventionRegistrationHistory } from 'app/models/delete-convention-registration-history.model';
import { EventConvention } from 'app/models/event-convention.model';
import { LinkGenderConventionExtension } from 'app/models/extensions/link-gender-convention-extension.model';
import { LOVConventionGender } from 'app/models/lov-convention-gender.model';
import { MRMValidators } from '@mrm/core';

export class LinkGenderConvention extends LinkGenderConventionExtension {
  linkGenderConventionDBID: number = 0;
  conventionGenderDBID: number = 0;
  conventionDBID: number = 0;
  isActive: boolean = false;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  isDefault: boolean = false;
  convention: EventConvention = null;
  conventionGender: LOVConventionGender = null;
  conventionRegistrations: ConventionRegistration[] = [];
  deleteConventionRegistrationHistories: DeleteConventionRegistrationHistory[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      linkGenderConventionDBID: new FormControl({ value: 0, disabled: disableAll }),
      conventionGenderDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      conventionDBID: new FormControl({ value: 0, disabled: disableAll }, [Validators.required, MRMValidators.number]),
      isActive: new FormControl({ value: false, disabled: disableAll }, [Validators.required]),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      isDefault: new FormControl({ value: false, disabled: disableAll }, [Validators.required]),
      conventionRegistrations: new FormArray([]),
      deleteConventionRegistrationHistories: new FormArray([])
    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'convention':
            form.addControl('convention', EventConvention.getForm(disableAll)); break;
          case 'conventiongender':
            form.addControl('conventionGender', LOVConventionGender.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of LinkGenderConvention. Please use one of the following navigational property: 'convention' | 'conventionGender'`);
        }
      }
    }

    return form;
  }
}